import "./Navbar.css";
import { ReactComponent as BookIcon } from "../assets/QHlFtT01.svg";
import { ReactComponent as SettingsIcon } from "../assets/rUzuxG01.svg";
import Logo from "../assets/Logo_colored.webp";
import Worlds from "../assets/Worlds.webp";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../firebase/AuthContext";
import { useIsMobile } from "../hooks/useIsMobile";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { user, loading } = useAuthContext();

  return (
    <div className="nav-container" style={{ display: loading && "none" }}>
      <div className="nav" style={{ height: isMobile && "80%" }}>
        <img
          src={Logo}
          className=" logo"
          style={{
            color: "white",
          }}
          onClick={() => {
            if (location.pathname !== "/") navigate("/");
          }}
        ></img>
        <div className="seperator"></div>
        <img
          className="nav-worlds"
          onClick={() => {
            if (location.pathname === "/")
              navigate("/worlds", { replace: true });
            if (location.pathname !== "/worlds") navigate("/worlds");
          }}
          src={Worlds}
          style={{
            filter:
              location.pathname === "/worlds" &&
              "drop-shadow(0px 0px 8px rgb(82, 229, 255))",
            borderRadius: "10px",
            transform: location.pathname === "/worlds" && "scale(1.15)",
          }}
        ></img>
        <div className="seperator"></div>
        <BookIcon
          className="nav-icon"
          style={{
            color: "white",
            filter:
              location.pathname === "/books" &&
              "drop-shadow(0px 0px 8px rgb(82, 229, 255))",
            transform: location.pathname === "/books" && "scale(1.15)",
          }}
          onClick={() => {
            if (location.pathname === "/")
              navigate("/books", { replace: true });
            if (location.pathname !== "/books") navigate("/books");
          }}
        ></BookIcon>
        <div className="seperator" style={{ display: !user && "none" }}></div>
        <SettingsIcon
          className="nav-icon"
          style={{
            color: "white",
            filter:
              location.pathname === "/settings" &&
              "drop-shadow(0px 0px 8px rgb(82, 229, 255))",
            transform: location.pathname === "/settings" && "scale(1.15)",
            display: !user && "none",
          }}
          onClick={() => {
            if (location.pathname === "/")
              navigate("/settings", { replace: true });
            if (location.pathname !== "/settings") navigate("/settings");
          }}
        ></SettingsIcon>
      </div>
    </div>
  );
}

export default Navbar;
